import { InjectionToken } from '@angular/core';

/**
 * Token para inyectar el código de país detectado por el servidor SSR.
 * Se provee en server.ts antes del render
 */
export const COUNTRY_CODE_TOKEN = new InjectionToken<string>('COUNTRY_CODE_TOKEN', {
    providedIn: 'root',
    factory: () => '',
});

export const USD_COUNTRIES = new Set<string>([
    'US',
    'CA',
]);

export const ES_LANG_COUNTRIES = new Set<string>([
    'ES', /*España*/      'MX', /*Mexico*/      'AR', /*Argentina*/            'CO', /*Colombia*/
    'PE', /*Perú*/        'VE', /*Venezuela*/   'EC', /*Ecuador*/              'GT', /*Guatemala*/
    'CU', /*Cuba*/        'BO', /*Bolivia*/     'DO', /*República Dominicana*/ 'HN', /*Honduras*/
    'PY', /*Paraguay*/    'SV', /*El Salvador*/ 'NI', /*Nicaragua*/            'CR', /*Costa Rica*/
    'PA', /*Panamá*/      'UY', /*Uruguay*/     'GQ', /*Guinea Ecuatorial*/    'CL', /*Chile*/
    'PR', /*Puerto Rico*/
]);

// Helpers

export function isUsdCountry(countryCode: string): boolean {
    return USD_COUNTRIES.has(countryCode.toUpperCase());
}

export function isESCountry(countryCode: string): boolean {
    return ES_LANG_COUNTRIES.has(countryCode.toUpperCase());
}
